import { motion } from "framer-motion";

export const Reveal = ({ children, delay = 0, className = "" }) => (
  <motion.div
    className={className}
    initial={{ opacity: 0, y: 40 }}
    whileInView={{ opacity: 1, y: 0 }}
    viewport={{ once: true, amount: 0.1 }}
    transition={{ duration: 0.8, delay, ease: [0.22, 1, 0.36, 1] }}
  >
    {children}
  </motion.div>
);

export const SectionLabel = ({ index, children }) => (
  <div className="flex items-center gap-4 font-mono text-xs uppercase tracking-[0.25em] text-[#56ED4A]">
    <span>{index}</span>
    <span className="h-px w-12 bg-[#56ED4A]" />
    <span className="text-zinc-300">{children}</span>
  </div>
);
